import React, { Component } from "react";
import { t } from "../../../components/CustomComponent.js";
import Logo from "../../../components/Logo.js";
import ICON from "../icons.js";
import { FOOTER_LINKS, goSection, openFreePost } from "../options.js";

/* ============================================================================
 * HomeFooter — แบรนด์ + ลิงก์ + ช่องทางติดตาม + สมัครรับข่าวสาร
 *
 * ช่องกรอกอีเมลอยู่คอลัมน์ขวาสุดของฟุตเตอร์ (ไม่ใช่แถบเต็มความกว้าง) เพราะเป็น
 * การกระทำรอง — คนที่เลื่อนมาถึงตรงนี้ส่วนใหญ่มาหาเบอร์ติดต่อมากกว่า
 * ยังไม่ต่อ API : ส่งอีเมลกลับไปให้หน้าแม่จัดการผ่าน props.onSubscribe
 *
 * ลิงก์ในคอลัมน์กลางพาไปปลายทางจริงได้เองทั้งหมด (ดู FOOTER_LINKS ใน options.js)
 * ทุกหน้าที่วางฟุตเตอร์นี้จึงได้พฤติกรรมชุดเดียวกันโดยไม่ต้องเขียนซ้ำ —
 * รวมถึง "ลงประกาศฟรี" ที่พาไปเพิ่มเพื่อน LINE ชุดเดียวกับปุ่มบนเมนู
 * props.onLink เหลือไว้เผื่อรายการชนิด action ที่ฟุตเตอร์ยังไม่รู้จัก
 * ========================================================================== */
export default class HomeFooter extends Component {
  state = { email: "" };

  submit = (event) => {
    event.preventDefault();
    const { onSubscribe } = this.props;
    if (onSubscribe) onSubscribe(this.state.email.trim());
    this.setState({ email: "" });
  };

  /* ลิงก์ 1 รายการในคอลัมน์กลาง — href ทุกแบบชี้ปลายทางจริง เพื่อให้คลิกกลางเปิด
     แท็บใหม่และคัดลอกลิงก์ได้ ส่วน onClick ดักไว้เพื่อเลื่อนแบบนุ่มเมื่ออยู่หน้าเดียวกัน */
  renderLink = (item) => {
    const { onLink } = this.props;
    const label = t(item.label);

    if (item.action) {
      return (
        <a
          href="#hm-footer"
          onClick={(e) => {
            e.preventDefault();
            if (item.action === "post") return openFreePost();
            if (onLink) onLink(item.label);
          }}
        >
          {label}
        </a>
      );
    }

    if (item.path) return <a href={item.path}>{label}</a>;

    return (
      <a
        href={`/${item.href}`}
        onClick={(e) => {
          e.preventDefault();
          goSection(item.href);
        }}
      >
        {label}
      </a>
    );
  };

  render() {
    const { data, socials = [] } = this.props;
    const year = new Date().getFullYear() + 543; // แสดงเป็น พ.ศ. ตามเอกสารไทย

    return (
      <footer className="hm-footer" id="hm-footer">
        <div className="hm-container">
          <div className="hm-footer__grid">
            {/* แบรนด์ */}
            <div className="hm-on-dark">
              <Logo size={42} />
              {/* สโลแกนเก็บเป็นคีย์แปลภาษาได้ (แบบเดียวกับ cta ของแบนเนอร์/แถบติดต่อ)
                  ถ้าผู้ดูแลพิมพ์ข้อความเองมา t() จะคืนค่านั้นกลับมาตรง ๆ */}
              <p className="hm-footer__brand-desc">{data?.tagline ? t(data.tagline) : ""}</p>
            </div>

            {/* ลิงก์ */}
            {FOOTER_LINKS.map((group) => (
              <div key={group.title}>
                <div className="hm-footer__title">{t(group.title)}</div>
                <ul className="hm-footer__list">
                  {group.items.map((item) => (
                    <li key={item.key}>{this.renderLink(item)}</li>
                  ))}
                </ul>
              </div>
            ))}

            {/* ติดตามเรา */}
            <div>
              <div className="hm-footer__title">{t("home_footer_follow")}</div>
              <div className="hm-footer__social">
                {socials.map((item) => (
                  <a key={item.uid} href="#hm-footer" aria-label={item.key} onClick={(e) => e.preventDefault()}>
                    <span className="hm-ico">{item.icon}</span>
                  </a>
                ))}
              </div>
            </div>

            {/* สมัครรับข่าวสาร */}
            <div>
              <div className="hm-footer__title">{data?.newsletter_title || ""}</div>
              <p className="hm-footer__news-desc">{data?.newsletter_desc || ""}</p>
              <form className="hm-news" onSubmit={this.submit}>
                <input
                  type="email"
                  className="hm-news__input"
                  placeholder={t("home_footer_email_placeholder")}
                  value={this.state.email}
                  onChange={(e) => this.setState({ email: e.target.value })}
                />
                <button type="submit" className="hm-news__btn" aria-label={t("home_footer_subscribe")}>
                  <span className="hm-ico">{ICON.arrow_right}</span>
                </button>
              </form>
            </div>
          </div>

          <div className="hm-footer__bottom">
            <div>
              © {year} {data?.company || "SafeSpace Life Living"}. {t("all_rights_reserved")}
            </div>
            <div className="hm-footer__bottom-links">
              <a href="/policy-privacy">{t("home_footer_privacy")}</a>
              <a href="/terms-of-use">{t("home_footer_terms")}</a>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
